import { ItemInput, UserItem } from "@directus/sdk";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import { IconButton, ListItem, ListItemText } from "@mui/material";
import { format } from "date-fns";
import React from "react";

import { Comment } from "../../../generated/gql/graphql";

type Props = {
  comment: Comment;
  editable: boolean;
  handleRemoveComment(id: string): void;
  setEditCommentId(id: string | undefined): void;
};

export function ListCommentItem(props: Props): React.ReactElement {
  const { comment, editable, setEditCommentId, handleRemoveComment } = props;

  // ToDo: Add First and Lastname

  if (!editable) {
    return (
      <ListItem className="px-0 pb-0" alignItems="flex-start">
        <ListItemText
          primary={
            <div className="flex justify-between">
              <div>{comment.id}</div>
              {comment.dateCreated && (
                <div className="text-[11px]">
                  {format(new Date(comment.dateCreated), "dd/MM/yyyy HH:mm")}
                </div>
              )}
            </div>
          }
          secondary={comment.comment}
        />
      </ListItem>
    );
  }

  return (
    <ListItem className="px-0 pb-0" alignItems="flex-start">
      <ListItemText
        primary={
          <span className="flex align-middle justify-between">
            {comment.id}
            <div className="text-[11px]">
              {comment.dateCreated &&
                format(new Date(comment.dateCreated), "dd/MM/yyyy HH:mm")}
              <IconButton
                onClick={() => setEditCommentId(comment.id)}
                className="ml-5"
                color="error"
                size="small"
              >
                <EditIcon fontSize="inherit" />
              </IconButton>
              <IconButton
                onClick={() => handleRemoveComment(comment.id)}
                className="ml-5"
                color="error"
                size="small"
              >
                <DeleteOutlineIcon fontSize="inherit" />
              </IconButton>
            </div>
          </span>
        }
        secondary={
          <>
            {/*{(comment.fname || comment.lname) && (*/}
            {/*    <Typography*/}
            {/*        sx={{display: "inline"}}*/}
            {/*        component="span"*/}
            {/*        variant="body2"*/}
            {/*        color="text.primary"*/}
            {/*    >*/}
            {/*        {comment.fname} {comment.lname} -*/}
            {/*    </Typography>*/}
            {/*)}*/}
            {` ${comment.comment}`}
          </>
        }
      />
    </ListItem>
  );
}
